export default __webpack_public_path__ + "static/festl-bad-reichenhall-preview-28648e130a7204d17da779b8fb747784.jpg";